import { Flex, Box, styled, StyleSystemProps } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledSectionRow = styled(Flex)``;
const sectionRowStyles: StyleSystemProps = {
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingY: 4,
};

export const StyledSectionTitleWrapper = styled(Flex)``;
const sectionTitleWrapperStyles: StyleSystemProps = {
  alignItems: 'center',
  width: '100%',
};

export const StyledIconWrapper = styled(Flex)``;
const iconWrapperStyles: StyleSystemProps = {
  justifyContent: 'center',
  alignItems: 'center',
  flex: `0 0 ${pxToRem(48)}`,
  marginRight: 4,
};

export const StyledIcon = styled(Box)``;
const iconStyles: StyleSystemProps = {
  width: '100%',
  height: '100%',
};

export const styles = {
  sectionRow: sectionRowStyles,
  sectionTitleWrapper: sectionTitleWrapperStyles,
  iconWrapper: iconWrapperStyles,
  icon: iconStyles,
};
